import * as types from './types';

export const setDataLoadingState = isDataLoading => {
  return {
    type: types.MARKETS_SET_DATA_LOADING_STATE,
    payload: { isDataLoading }
  };
};

export const setRequestLoadingState = isRequestLoading => {
  return {
    type: types.MARKETS_SET_REQUEST_LOADING_STATE,
    payload: { isRequestLoading }
  };
};

export const setError = error => {
  return {
    type: types.MARKETS_SET_ERROR,
    payload: { error }
  };
};

export const resetError = () => {
  return {
    type: types.MARKETS_RESET_ERROR,
    payload: { error: '' }
  };
};

export const setMarketList = marketList => {
  return {
    type: types.MARKETS_SET_MARKET_DATA,
    payload: { marketList }
  };
};

export const setClientList = clientList => {
  return {
    type: types.MARKETS_SET_CLIENT_LIST,
    payload: { clientList }
  };
};
